import {showFeetInches, showBigLinearForce, showKips, showKipFt} from '../../units/units.js'
import {openPointLoadDialog, openMomentLoadDialog, openUniformLoadDialog, openLinearLoadDialog} from './load-editor-dialog-component.js'

class LoadDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('shear-moment-project-loaded', async (event) => this.onUpdate(event.detail), true)
    document.addEventListener('update-load-table', async (event) => this.onUpdate(event.detail), true)
  }

  onUpdate(beam) {
    var str = "<br><table class='table text-center' id='load-table'>"
    str += "<th style='width:50px;'>Load</th><th style='width:50px;'>Type</th>"
    str += "<th style='width:200px;'>Location</th>"
    str += "<th>Magnitude</th>"
    str += "</tr></thead>"
    let loadNum = 0;
    for(let i = 0; i < beam.distLoads.length; i++) {
        const load = beam.distLoads[i];
        loadNum += 1;
        const loadType = load.isLinear ? "Linear" : "Uniform"
        const loadId = load.isLinear ? 'wsLinearLoad_' + i : 'wsUniformLoad_' + i;
        str += `<tr class='${loadId}' style="cursor: pointer;">`
        str += `<td style='width:50px;' >${loadNum}</td>`
        str += `<td>${loadType}</td>`
        str += `<td>${showFeetInches(load.x1)} to ${showFeetInches(load.x2)}</td>`
        str += makeDistributedLoadCell(load.D, load.D2, load.isLinear)
        str += "</tr>";
    }
    for(let i = 0; i < beam.pointLoads.length; i++) {
        const load = beam.pointLoads[i]
        loadNum += 1;
        const loadType = load.isMoment ? "Moment" : "Point"
        const loadId = load.isMoment ? 'wsMoment_' + i : 'wsPointLoad_' + i
        let showFunc = load.isMoment ? showKipFt : showKips
        let units = load.isMoment ? 'kip-ft' : 'kips'
        str += `<tr class='${loadId}' style="cursor: pointer;">`
        str += `<td style='width:50px;'>${loadNum}</td>`
        str += `<td>${loadType}</td>`
        str += `<td>${showFeetInches(load.x)}</td>`
        str += `<td>${showFunc(load.D)} ${units}</td>`
        str += "</tr>"
    }
    str += "</table>";

    document.getElementById('load-table-div').innerHTML = str

    
    const rows = document.getElementById("load-table").rows
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i]
      row.onclick = () => console.log('clicked')
      const myClass = row.classList[0]
      if (myClass === undefined) { 
        continue 
      } else if (myClass.match(/wsUniformLoad/) && myClass.match(/wsUniformLoad/).length > 0) {
        row.onclick = () => openUniformLoadDialog(parseInt(myClass.split(/wsUniformLoad_/)[1]))
      } else if (myClass.match(/wsLinearLoad/) && myClass.match(/wsLinearLoad/).length > 0) {
        row.onclick = () => openLinearLoadDialog(parseInt(myClass.split(/wsLinearLoad_/)[1]));
      } else if (myClass.match(/wsPointLoad/) && myClass.match(/wsPointLoad/).length > 0) {
        row.onclick = () => openPointLoadDialog(parseInt(myClass.split(/wsPointLoad_/)[1]));
      } else if (myClass.match(/wsMoment/) && myClass.match(/wsMoment/).length > 0) {
        row.onclick = () => openMomentLoadDialog(parseInt(myClass.split(/wsMoment_/)[1]));
      }
    }
}
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="load-dialog" tabindex="-1" role="dialog"
      aria-labelledby="load-dialog-label" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Loads</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <button id="add-uniform-load-button" type="button" class="btn btn-success btn-md" data-toggle="modal">
              Add Uniform
            </button>
            <button id="add-linear-load-button" type="button" class="btn btn-success btn-md" data-toggle="modal">
              Add Linear
            </button>
            <button id="add-point-load-button" type="button" class="btn btn-success btn-md" data-toggle="modal">
              Add Point
            </button>
            <button id="add-moment-load-button" type="button" class="btn btn-success btn-md" data-toggle="modal">
              Add Moment
            </button>
            <div id="load-table-div"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
      `
      // note: we use an annoymous function here capturing the event but passing null to the open dialog functions
      document.getElementById('add-uniform-load-button').onclick = (event) => openUniformLoadDialog()
      document.getElementById('add-linear-load-button').onclick = (event) => openLinearLoadDialog()
      document.getElementById('add-point-load-button').onclick = (event) => openPointLoadDialog()
      document.getElementById('add-moment-load-button').onclick = (event) => openMomentLoadDialog()
  }
}

customElements.define('load-dialog-component', LoadDialogComponent);

function makeDistributedLoadCell(load1, load2, isLinear) {
  if (isLinear) {
      return `<td><p>${showBigLinearForce(load1)} kip/ft</p>${showBigLinearForce(load2)} kip/ft</td>`
  }
  return `<td>${showBigLinearForce(load1)} kip/ft</td>`
}